import { render, staticRenderFns } from "./SvgAvatar.vue?vue&type=template&id=5ccfbbee&scoped=true"
import script from "./SvgAvatar.vue?vue&type=script&lang=ts"
export * from "./SvgAvatar.vue?vue&type=script&lang=ts"
import style0 from "./SvgAvatar.vue?vue&type=style&index=0&id=5ccfbbee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccfbbee",
  null
  
)

export default component.exports